import { Component, OnInit } from '@angular/core';
import * as CanvasJS from '../canvasjs.min';
import * as Chart from '../chart';
import jspdf from 'jspdf';
import html2canvas from 'html2canvas';
import { CommonService } from '../common.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
declare var $: any;
@Component({
  selector: 'app-dashboard-graph',
  templateUrl: './dashboard-graph.component.html',
  styleUrls: ['./dashboard-graph.component.css']
})
export class DashboardGraphComponent implements OnInit {

  loginresponse: any;
  userrole: any;
  farm_userrole: any;
  form_id: any;
  getlistApi: any;
  getlistApi1: any;
  getlistApi2: any;
  getlistApi3: any;
  get_data: any;
  get_data1: any;
  get_data2: any;
  get_data3: any;
  chartData: any;
  Genderchart: any;
  Formschart: any;
  Deathchart: any;
  selectallvalue: any;
  getfarmsListData: any;
  loadspeciesValue: any;
  getspeciesvalue: any;
  addUrl: any;
  isLoading: true;
  speciesloaddata: any;
  get_age: any;
  ageUrl: any;
  constructor(private commonService: CommonService) { }

  async ngOnInit(): Promise<void> {
    this.loginresponse = JSON.parse(sessionStorage.getItem('userrole'));
    this.userrole = this.loginresponse.read_status;
    this.farm_userrole = this.loginresponse.user_farm_id;
    if (this.farm_userrole) {
      this.form_id = this.farm_userrole;
    } else {
      this.form_id = null;
    }

    console.log('farm_iddddddd', this.farm_userrole)

    this.isLoading = true;
    var table;
    $('.selectpicker').selectpicker('refresh');
    //$('#reportrange_date').daterangepicker('refresh');
    //$('#reportrange_date').daterangepicker('setDate', 0);
    this.getlistApi = (this.form_id != null) ? '/farms/' + this.form_id : "/farms";
    //this.getlistApi='api/farms/'+this.form_id;
    (await this.commonService.getApi(this.getlistApi)).subscribe(
      async (res) => {
        $(function () {
          table = $("#myTable").DataTable();
        })
        this.getfarmsListData = (this.form_id != null) ? [res.data] : res.data;
        this.getfarmsListData.unshift({ tnfr_id: null, tnfr_name: "Select Farm Name" });
        console.log('table_data', res)
      });

    setTimeout(function () {
      $('#reportrange_date').daterangepicker('refresh');
      $('.selectpicker').selectpicker('refresh');   // refresh the selectpicker with fetched courses
      //$('#reportrange_date').daterangepicker('refresh');
    }, 1500);
    $('#farmname').change(async () => {
      $("#speciesid").find('option').remove().end();
      console.log($('#farmname').val())
      this.selectallvalue = $('#farmname').val();
      var farmvalue = "";
      farmvalue = this.selectallvalue.toString();
      this.loadspeciesValue = {
        "farms_id": farmvalue
      };
      console.log(this.loadspeciesValue.farm_id)
      if (farmvalue != "null") {
        //species load in select dropdown based on farm select api call
        this.addUrl = "/species/farms";
        (await this.commonService.postApi(this.addUrl, this.loadspeciesValue)).subscribe(
          res => {
            this.speciesloaddata = res.data;
            this.speciesloaddata.unshift({ id: null, name: "Select Species Name" });
            console.log(this.speciesloaddata)

          })

      } else {
        $('#Speciesname').val('null');
        this.speciesloaddata = [{ id: null, name: "Select Species Name" }];
        $('#BreedName').val('null');
        this.getspeciesvalue = [{ id: null, name: "Select Breed Name" }];
        $('#age').val('null');
        this.get_age = [{ tnag_id: null, tnag_name: "Select Age", tnag_time_range: '0' }];
      }
      setTimeout(function () {
        $('.selectpicker').selectpicker('refresh');   // refresh the selectpicker with fetched courses
      }, 1500);
    });




    this.get_datas();

    $(document).on('change', '#farmname', function () {
      $('.myFakeClass').dropdown('toggle');
    });
    $(document).on('change', '#Speciesname', function () {
      $('.myFakeClass1').dropdown('toggle');
    });
    $(document).on('change', '#BreedName', function () {
      $('.myFakeClass2').dropdown('toggle');
    });
    $(document).on('change', '#age', function () {
      $('.myFakeClass3').dropdown('toggle');
    });
  }

  async breedselectbyspecies(event) {
    console.log(event.target.value);
    if (event.target.value != 'null') {
      this.addUrl = "/breeds/species/" + event.target.value;
      (await this.commonService.getApi(this.addUrl)).subscribe(
        res => {
          this.getspeciesvalue = res.data;
          this.getspeciesvalue.unshift({ id: null, name: "Select Breed Name" });
          console.log(this.getspeciesvalue);
        });
      this.ageUrl = "/species/age_group/all_category/?species_id=" + event.target.value;
      (await this.commonService.getApi(this.ageUrl)).subscribe(
        res => {
          this.get_age = res.data;
          this.get_age.unshift({ tnag_id: null, tnag_name: "Select Age", tnag_time_range: '0' });
          console.log(this.get_age);
        });

    } else {
      $('#BreedName').val('null');
      this.getspeciesvalue = [{ id: null, name: "Select Breed Name" }];
      $('#age').val('null');
      this.get_age = [{ tnag_id: null, tnag_name: "Select Age", tnag_time_range: '0' }];
    }
    setTimeout(function () {
      $('.selectpicker').selectpicker('refresh');   // refresh the selectpicker with fetched courses
    }, 1000);
  }


  public exportdata() {
    let data = document.getElementById('contentToConvert');
    html2canvas(data).then(canvas => {
      const contentDataURL = canvas.toDataURL('image/png')
      let pdf = new jspdf('l', 'cm', 'a4'); //Generates PDF in landscape mode
      // let pdf = new jspdf('p', 'cm', 'a4'); Generates PDF in portrait mode
      pdf.addImage(contentDataURL, 'PNG', 0, 0, 29.7, 21.0);
      pdf.save('Dashboard.pdf');
    });
  }



  date_format(dateObject) {
    var d = new Date(dateObject);
    let day = d.getDate();
    var month = d.getMonth() + 1;
    var year = d.getFullYear();
    var day1;
    var month1;
    if (day < 10) {
      day1 = "0" + day;
    } else {
      day1 = day;
    }
    if (month < 10) {
      month1 = "0" + month;
    } else {
      month1 = month;
    }
    var date = year + "-" + month1;
    return date;
  };


  async get_general() {
    (await this.commonService.getApi(this.getlistApi)).subscribe(
      (res) => {
        console.log('get_general_______datas', res.data);

        this.get_data = res;
        this.chartData = {
          title: "Mortality Data",
          type: 'ColumnChart',
          data: this.get_data.data,
          columnNames: this.get_data.columnNames,
          options: {
            vAxis: {
              title: ''
            },
            //	legend: { position: 'bottom', maxLines: 3 },
            bar: { groupWidth: '75%' },
            pointsVisible: true
          },
          width: 1200,
          height: 300
        };
      });
  }


  async get_gender() {
    (await this.commonService.getApi(this.getlistApi1)).subscribe(
      (res) => {
        console.log(res.data);
        this.get_data1 = res.data;
        this.Genderchart = {
          title: 'Gender Data',
          type: 'PieChart',
          data: this.get_data1,
          columnNames: ['Gender', 'Percentage'],
          options: {
            pieHole: 0.4
          },
          width: 500,
          height: 300
        };
      });
  }


  async get_species_date() {
    (await this.commonService.getApi(this.getlistApi2)).subscribe(
      (res) => {
        console.log(res.data);
        this.get_data2 = res.data;
        this.Formschart = {
          title: 'Total Species counts',
          type: 'PieChart',
          data: this.get_data2,
          columnNames: ['Species', 'Percentage'],
          options: {
            pieHole: 0.5
          },
          width: 1200,
          height: 400
        };
      });
  }


  async get_death() {
    (await this.commonService.getApi(this.getlistApi3)).subscribe(
      (res) => {
        console.log(res.data);
        this.get_data3 = res;
        this.Deathchart = {
          title: 'Death Details',
          type: 'ColumnChart',
          data: this.get_data3.data,
          columnNames: this.get_data3.columnNames,
          options: {
            isStacked: true,
            legend: { position: 'bottom', maxLines: 3 },
            bar: { groupWidth: '75%' },
          },
          width: 700,
          height: 300
        };
      });
  }


  get_datas() {
    var current_year = (new Date()).getFullYear();
    console.log("date " + $("input[name='daterangepicker_start']").val());
    var from_date = ($("input[name='daterangepicker_start']").val() != undefined) ? this.date_format($("input[name='daterangepicker_start']").val()) : (current_year - 1) + '-04';
    var to_date = ($("input[name='daterangepicker_end']").val() != undefined) ? this.date_format($("input[name='daterangepicker_end']").val()) : (new Date()).getFullYear() + '-03';
    var farm_id = (this.form_id != null) ? this.form_id : $('#farmname').val();
    //	var farm_id=$('#farmname').val();
    var species_id = $('#Speciesname').val();
    var breed_id = $('#BreedName').val();
    var age = $('#age').val();
    //var species_id=null;
    //var breed_id=null;
    //var age='';
    this.getlistApi = "/dashboard/general/?from_date=" + from_date + "&to_date=" + to_date + "&farm_id=" + farm_id + "&species_id=" + species_id + "&breed_id=" + breed_id + "&age=" + age;
    console.log('getlistApi_____data', this.getlistApi)
    //this.getlistApi1="/dashboard/gender/?from_date="+from_date+"&to_date="+to_date+"&farm_id="+farm_id+"&species_id="+species_id+"&breed_id="+breed_id+"&age="+age;
    this.getlistApi2 = "/dashboard/species/?from_date=" + from_date + "&to_date=" + to_date + "&farm_id=" + farm_id + "&species_id=" + species_id + "&breed_id=" + breed_id + "&age=" + age;
    console.log('getlistApi_____data', this.getlistApi2)

    //this.getlistApi3="/dashboard/death/?from_date="+from_date+"&to_date="+to_date+"&farm_id="+farm_id+"&species_id="+species_id+"&breed_id="+breed_id+"&age="+age;
    this.get_general();
    //this.get_gender();
    this.get_species_date();
    //	this.get_death();
  }

}
